const { toMatchImageSnapshot } = require('jest-image-snapshot');
import puppeteer from "puppeteer";
import { Page } from "puppeteer/lib/types";
export { getTestStory } from "./regression-test-stories";

expect.extend({ toMatchImageSnapshot });

const minimal_args = [
    '--autoplay-policy=user-gesture-required',
    '--disable-background-networking',
    '--disable-background-timer-throttling',
    '--disable-backgrounding-occluded-windows',
    '--disable-breakpad',
    '--disable-client-side-phishing-detection',
    '--disable-component-update',
    '--disable-default-apps',
    '--disable-dev-shm-usage',
    '--disable-domain-reliability',
    '--disable-extensions',
    '--disable-features=AudioServiceOutOfProcess',
    '--disable-hang-monitor',
    '--disable-ipc-flooding-protection',
    '--disable-notifications',
    '--disable-offer-store-unmasked-wallet-cards',
    '--disable-popup-blocking',
    '--disable-print-preview',
    '--disable-prompt-on-repost',
    '--disable-renderer-backgrounding',
    '--disable-setuid-sandbox',
    '--disable-speech-api',
    '--disable-sync',
    '--hide-scrollbars',
    '--ignore-gpu-blacklist',
    '--metrics-recording-only',
    '--mute-audio',
    '--no-default-browser-check',
    '--no-first-run',
    '--no-pings',
    '--no-sandbox',
    '--no-zygote',
    '--password-store=basic',
    '--use-gl=swiftshader',
    '--use-mock-keychain',
  ];

interface RegressionTest {
    storyId: string;
    baseUrl?: string;
    componentTag?: string;
    performActions?: (page: Page) => Promise<any>;
    pageHeight?: number;
    pageWidth?: number;
    scale?: number;
    threshold?: number;
    fullPage?: boolean;
}

const baseIframeUrl = "iframe.html?id=";

export const regressionTest = async ({
    storyId,
    baseUrl,
    componentTag,
    performActions,
    pageHeight,
    pageWidth,
}: RegressionTest) => {
    /**
     * increases timeout failure for jest (this function is quite heavy anc could sometimes
     * fail just because it has not had the time to execute, when there is a low jest timeout set.
    */
    jest.setTimeout(120000);
    const browser = await puppeteer.launch({ headless: true, args: minimal_args });
    try {
        const page = await browser.newPage();
        page.setDefaultNavigationTimeout(90000);
        if (pageWidth !== undefined && pageHeight !== undefined) await page.setViewport({ width: pageWidth, height: pageHeight });
        await page.goto((baseUrl || 'http://localhost:3000/') + baseIframeUrl + storyId);
        if (componentTag) await page.waitForSelector(`${componentTag}.hydrated`);
        if (performActions !== undefined) await performActions(page);
        await new Promise(r => setTimeout(r, 2200));
        const image = await page.screenshot();
        //@ts-ignore
        expect(image).toMatchImageSnapshot({
            failureThreshold: 0.01,
            failureThresholdType: 'percent',
        });
    } finally {
        await browser.close();
    }
}
